import { compose, withProps, setPropTypes, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';

// Import components
import TabSelectorEntry from "./TabSelectorEntry";
import { showAppReqCountSelector, showActionsCountSelector, appReqCountSelector, actionsCountSelector } from "../../../../store/selectors/application";
var enhancer = compose(withProps(function (_ref) {
  var props = _ref.props;
  var notesLength = props ? props.count : 0;
  return {
    notesLength: notesLength
  };
}), withHandlers({
  onClick: function onClick(_ref2) {
    var _onClick = _ref2.onClick,
      label = _ref2.label;
    return function () {
      _onClick(label);
    };
  }
}), connect(createStructuredSelector({
  showAppReqCount: showAppReqCountSelector,
  // control displaying count notifier on applicant req tab
  showActionsCount: showActionsCountSelector,
  // control displaying count notifier on actions tab
  appReqCount: appReqCountSelector,
  // value for app req tab notifier
  actionsCount: actionsCountSelector // value for actions tab notifier
})), setPropTypes({
  icon: PropTypes.string,
  label: PropTypes.string,
  notesLength: PropTypes.number,
  onClick: PropTypes.func,
  props: PropTypes.object,
  selected: PropTypes.bool,
  showAppReqCount: PropTypes.bool,
  showActionsCount: PropTypes.bool,
  appReqCount: PropTypes.number,
  actionsCount: PropTypes.number
}));
export default enhancer(TabSelectorEntry);